import React from 'react';
import { getTranslation } from '@/lib/i18n';
import { Button } from '@/components/ui/button';
import { AlertTriangle, RefreshCw } from 'lucide-react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleRetry = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-[#faf8f5] flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-2xl border border-gray-100 shadow-[0_4px_20px_-4px_rgba(0,0,0,0.06)] p-8 text-center">
            <h1 className="font-poppins text-2xl font-bold text-[#1a1a2e] tracking-wide mb-2">
              SalonSync
            </h1>
            <div className="flex justify-center my-6">
              <div className="w-16 h-16 rounded-2xl bg-amber-100 flex items-center justify-center">
                <AlertTriangle className="w-8 h-8 text-amber-600" />
              </div>
            </div>
            <p className="font-poppins text-xl font-semibold text-[#1a1a2e] mb-1">
              {getTranslation('errb_title')}
            </p>
            <p className="text-base text-gray-500 mb-6">
              {getTranslation('errb_subtitle')}
            </p>
            <Button
              onClick={this.handleRetry}
              className="h-14 px-8 rounded-xl bg-[#f0a500] hover:bg-[#d69400] text-[#1a1a2e] text-lg font-semibold gap-2"
            >
              <RefreshCw className="w-5 h-5" />
              {getTranslation('errb_retry')}
            </Button>
            <p className="text-sm text-gray-400 mt-6">
              {getTranslation('errb_logged')}
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
